import { render, staticRenderFns } from "./formScreen.vue?vue&type=template&id=8cc97460&scoped=true&"
import script from "./formScreen.vue?vue&type=script&lang=js&"
export * from "./formScreen.vue?vue&type=script&lang=js&"
import style0 from "./formScreen.vue?vue&type=style&index=0&id=8cc97460&lang=scss&scoped=true&"
import style1 from "./formScreen.vue?vue&type=style&index=1&id=8cc97460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc97460",
  null
  
)

export default component.exports